/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';

import * as actions from './actions';
import * as constants from './constants';
import * as D from './deps';
import reducer from './reducer';
import watchers from './sagas/watchers';
import * as utils from './utils';

export default D.createDomainModule({
  // The name that will be used as the reducer key
  // and the string to be used when loading the domain
  name: 'backstage',
  actions,
  utils,
  constants,
  // @ts-expect-error Type '({ actionType: "GET_CATALOG_DETAILS_FOR_BACKSTAGE"; handler: ({ payload: { pandoraId, redirectOnNotFound, withCollaborations },...
  watchers,
  reducer,
  // Any components that should live in this domain
  // Meaning when this component is loaded this domain will also load
  components: {
    Backstage: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(/* webpackChunkName: "c_backstage" */ './components/Backstage')
        }
      />
    ),
    BackstageArtistAllSongs: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_artist_all_songs" */ './components/BackstageArtistAllSongs',
          )
        }
      />
    ),
    BackstageArtistAllAlbums: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_artist_all_albums" */ './components/pages/BackstageArtistAllAlbums/BackstageArtistAllAlbums',
          )
        }
      />
    ),
    BackstageTrackSimilarSongs: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_track_similar_songs" */ './components/BackstageTrackSimilarSongs',
          )
        }
      />
    ),
    BackstageTrackFullLyrics: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_track_full_lyrics" */ './components/BackstageTrackFullLyrics',
          )
        }
      />
    ),
    BackstageTrackFullCredits: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_track_full_credits" */ './components/BackstageTrackFullCredits',
          )
        }
      />
    ),
    BackstageFullDescription: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_full_description" */ './components/BackstageFullDescription',
          )
        }
      />
    ),
    BackstageAllPlaylists: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_full_description" */ './components/BackstageAllPlaylists',
          )
        }
      />
    ),
    BackstageAllStations: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_full_description" */ './components/BackstageAllStations',
          )
        }
      />
    ),
    BackstageBase: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(/* webpackChunkName: "c_backstage_base" */ './components/BackstageBase')
        }
      />
    ),
    BackstageGenre: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(/* webpackChunkName: "c_backstage_genre" */ './components/BackstageGenre')
        }
      />
    ),
    BackstageTrackListItem: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_track_list_item" */ './components/BackstageTrackListItem',
          )
        }
      />
    ),
    BackstageRowColumns: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_row_columns" */ './components/BackstageRowColumns',
          )
        }
      />
    ),
    BackstageRowGrid: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_row_grid" */ './components/BackstageRowGrid',
          )
        }
      />
    ),
    BackstageLongPlayButton: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_long_play_button" */ './components/BackstageLongPlayButton',
          )
        }
      />
    ),
    BackstageHeroSidebarImage: (props: $TSFixMe) => (
      <D.AsyncComponent
        {...props}
        importer={() =>
          System.import(
            /* webpackChunkName: "c_backstage_hero_sidebar_image" */ './components/BackstageHeroSidebarImage',
          )
        }
      />
    ),
  },
  // @ts-expect-error TS(2322) FIXME: Type '() => void' is not assignable to type '(stor... Remove this comment to see the full error message
  onLoad() {},
  onStart() {},
  onStop() {},
});
